import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled, { css } from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var StyledTable = styled.table.withConfig({
  displayName: "Table__StyledTable",
  componentId: "sc-16hs8pa-0"
})(["width:100%;font-size:16px;border-collapse:collapse;border-spacing:0;th:first-child{padding-left:6px;}tr{td,th{height:1px;}}"]);
export var StyledTr = styled.tr.withConfig({
  displayName: "Table__StyledTr",
  componentId: "sc-16hs8pa-1"
})(["&:last-child{td{border-bottom:0;}}"]);
export var StyledTh = styled.th.withConfig({
  displayName: "Table__StyledTh",
  componentId: "sc-16hs8pa-2"
})(["height:70px;padding:0 12px 9px;border-bottom:1px solid ", ";font-weight:700;white-space:nowrap;color:", ";", ";", ";", ";", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.terciaryL;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.terciary;
}, function (_ref3) {
  var right = _ref3.right;
  return right ? 'text-align: right;' : '';
}, function (_ref4) {
  var left = _ref4.left;
  return left ? 'text-align: left;' : '';
}, function (_ref5) {
  var center = _ref5.center;
  return center ? 'text-align: center;' : '';
}, function (_ref6) {
  var bold = _ref6.bold;
  return bold ? 'font-weight: 700;' : '';
});
export var StyledTd = styled.td.withConfig({
  displayName: "Table__StyledTd",
  componentId: "sc-16hs8pa-3"
})(["height:70px;padding:18px 12px;border-bottom:1px solid ", ";background-color:transparent;font-weight:400;white-space:normal;color:", ";", " &[scope='row']{position:-webkit-sticky;position:sticky;z-index:1;z-index:3;left:0;width:", "%;", ";", ";}&:not([scope='row']){z-index:2;width:", "%;", ";", ";", ";}", ";", ";", ";", ";", ";"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.terciaryL;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.terciary;
}, function (_ref9) {
  var small = _ref9.small;
  return small && css(["height:auto;padding:8px 9px;", ";", ";", ";"], getFont(-1), minMediaQueries.miniDesktop(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      ", ";\n    "])), getFont(0)), minMediaQueries.desktop(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      padding: 12px 12px;\n    "]))));
}, 100 / 6, minMediaQueries.phone(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      // min-width: 130px;\n      // max-width: 130px;\n    "]))), minMediaQueries.miniDesktop(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      // min-width: 230px;\n    "]))), 100 / 6, minMediaQueries.phone(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      ", ";\n      ", ";\n    "])), function (_ref10) {
  var minWidth = _ref10.minWidth;
  return minWidth ? "width: ".concat(minWidth, "px") : '';
}, function (_ref11) {
  var minWidth = _ref11.minWidth;
  return minWidth ? "min-width: ".concat(minWidth, "px") : '';
}), minMediaQueries.tablet(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n      // min-width: 180px;\n    "]))), minMediaQueries.miniDesktop(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      // min-width: 225px;\n    "]))), function (_ref12) {
  var scope = _ref12.scope;
  return scope && css(["z-index:3;left:0;background-color:white;&:before{position:absolute;top:-1px;bottom:-1px;right:-8px;width:8px;content:'';background:linear-gradient(to right,rgba(0,0,0,0.05),transparent);}"]);
}, function (_ref13) {
  var right = _ref13.right;
  return right ? 'text-align: right;' : '';
}, function (_ref14) {
  var left = _ref14.left;
  return left ? 'text-align: left;' : '';
}, function (_ref15) {
  var center = _ref15.center;
  return center ? 'text-align: center;' : '';
}, function (_ref16) {
  var bold = _ref16.bold;
  return bold ? 'font-weight: 700;' : '';
});